import React from 'react';
import Right from '../icons/Tick.svg';
export const TickIcon = () => {
  return <img src={Right} alt="tick-icon" />;
};
